import { fontSize } from '../../../../styles/themes/vad/font';

export const styles = theme => {
  let customStyle = {
    paralaxImgWrapper: {
      position: 'relative',
      display: 'block',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      '& .img-to-animate': {
        width: '100%',
        height: '100%',
      },
      '&.has-paralax': {
        '& .img-to-animate': {
          position: 'absolute',
          backfaceVisibility: 'hidden',
          top: 0,
          left: 0,
          display: 'block',
          width: '120%',
          height: '120%',
        },
      },
    },
    root: {
      position: 'relative',
      display: 'block',
      width: '100%',
      height: '100%',
      color: 'transparent',
      fontSize: fontSize.s0Rem,
    },
    fallbackBackground: {
      backgroundColor: theme.palette.background.InfoBG,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right',
      backgroundSize: 'contain',

      [theme.breakpoints.down('md')]: {
        backgroundPosition: 'bottom right',
      },
    },
    ...[
      { size: 'm', bp: 'md', dir: 'down' },
      { size: 't', bp: 'md', dir: 'up' },
      { size: 'd', bp: 'lg', dir: 'up' },
    ].reduce(
      (r, viewport) => ({
        ...r,
        ...[
          { ratio: '', paddingTop: '' }, //first line is not getting pick due to some unknown reason that is why added dummy line, will be removed later
          { ratio: '1x1', paddingTop: '100%' },
          { ratio: '2x1', paddingTop: '50%' },
          { ratio: '3x1', paddingTop: '33.333%' },
          { ratio: '16x9', paddingTop: '56.25%' },
          { ratio: '16x9-m', paddingTop: '56.25%' },
          { ratio: '4x3', paddingTop: '75%' },
          { ratio: '2x3', paddingTop: '75%' },
          { ratio: '4x5', paddingTop: '100%' },
          { ratio: '3x2', paddingTop: '66.67%' },
          { ratio: '5x4', paddingTop: '66.67%' },
          { ratio: '3x2-m', paddingTop: '66.67%' },
          { ratio: '3x2-card', paddingTop: '66.67%' },
          { ratio: '16x6', paddingTop: '37.5%' },
        ].reduce((rr, ratio) => ({
          ...rr,
          ...{
            [`aspectRatio--${viewport.size}__${ratio.ratio}`]: {
              [theme.breakpoints[viewport.dir](viewport.bp)]: {
                paddingTop: ratio.paddingTop,
                '& img': {
                  position: 'absolute',
                  top: '0',
                  left: '0',
                },
              },
            },
          },
        })),
      }),
      {}
    ),
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      overflow: 'hidden',

      '&.noRendition': {
        height: 'inherit',
      },
    },
    width95: {
      width: '95px',
      height: '95px',
      '& img': {
        backgroundSize: '90% auto'
      }
    },
    '& .fallback': {
      objectFit: 'cover',
    },
  };
  return customStyle;
};
